(function initSessionTokenManager() {
  try {
    const ACTIVE_TABS_KEY = 'activeTabsCount';
    const SESSION_MODE_KEY = 'sessionMode'; // 'temporary' | 'persistent'
    const TOKEN_KEY = 'token';
    const TAB_ALIVE_MARKER = 'tabAlive'; // sessionStorage marker, survives reloads but not tab close

    try {
      const legacyToken = sessionStorage.getItem(TOKEN_KEY);
      if (legacyToken && !localStorage.getItem(TOKEN_KEY)) {
        localStorage.setItem(TOKEN_KEY, legacyToken);
        if (!localStorage.getItem(SESSION_MODE_KEY)) {
          localStorage.setItem(SESSION_MODE_KEY, 'temporary');
        }
        sessionStorage.removeItem(TOKEN_KEY);
      }
    } catch (_) {
    }

    function getCount() {
      try {
        const raw = localStorage.getItem(ACTIVE_TABS_KEY);
        const n = parseInt(raw, 10);
        return Number.isFinite(n) ? n : 0;
      } catch (_) {
        return 0;
      }
    }

    function setCount(n) {
      try {
        if (n <= 0) {
          localStorage.removeItem(ACTIVE_TABS_KEY);
        } else {
          localStorage.setItem(ACTIVE_TABS_KEY, String(n));
        }
      } catch (_) {
      }
    }

    function getSessionMode() {
      try {
        return localStorage.getItem(SESSION_MODE_KEY);
      } catch (_) {
        return null;
      }
    }

    function clearAllForTemporarySession() {
      try {
        localStorage.removeItem(TOKEN_KEY)
        localStorage.clear();
      } catch (_) {
      }

      try {
        sessionStorage.removeItem(TOKEN_KEY);
      } catch (_) {
      }
    }

    let hadTabAliveMarker = false;
    try {
      hadTabAliveMarker = sessionStorage.getItem(TAB_ALIVE_MARKER) === '1';
      sessionStorage.setItem(TAB_ALIVE_MARKER, '1');
    } catch (_) {
      hadTabAliveMarker = false;
    }

    if (!hadTabAliveMarker && getCount() <= 0 && getSessionMode() === 'temporary') {
      clearAllForTemporarySession();
    }

    setCount(getCount() + 1);

    window.addEventListener('beforeunload', () => {
      const next = getCount() - 1;
      setCount(next);
    });
  } catch (_) {
  }
})();
